import { memo } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

/**
 * FlagFilters - Renders the Duplicates/Legacy/Stalled toggle chips
 */
const FlagFilters = memo(({
  duplicatesOnly,
  legacyLeadsOnly,
  stalledOnly,
  onDuplicatesChange,
  onLegacyChange,
  onStalledChange,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        px: 0.75,
        py: 0.5,
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fafafa',
        alignItems: 'center',
        height: 34,
      }}
    >
    <Typography
      variant='caption'
      sx={{ fontSize: 10, fontWeight: 600, letterSpacing: 0.5, mr: 0.5 }}
    >
      Flags
    </Typography>
    <Chip
      size='small'
      label='Duplicates'
      variant={duplicatesOnly ? 'filled' : 'outlined'}
      color={duplicatesOnly ? 'warning' : undefined}
      onClick={onDuplicatesChange}
      sx={{ height: 24 }}
    />
    <Chip
      size='small'
      label='Legacy Leads'
      variant={legacyLeadsOnly ? 'filled' : 'outlined'}
      color={legacyLeadsOnly ? 'primary' : undefined}
      onClick={onLegacyChange}
      sx={{ height: 24 }}
    />
    <Chip
      size='small'
      label='Stalled'
      variant={stalledOnly ? 'filled' : 'outlined'}
      color='default'
      onClick={onStalledChange}
      sx={{
        height: 24,
        bgcolor: stalledOnly ? '#6d4c41' : undefined,
        color: stalledOnly ? '#fff' : 'inherit',
      }}
    />
    </Box>
  );
});

FlagFilters.displayName = 'FlagFilters';

export default FlagFilters;
